import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { PrivacyProvider } from "./lib/privacy";
import { initializeTheme } from "./lib/theme";
import { router } from "./router";
import "./styles.css";

initializeTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false
    }
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PrivacyProvider>
        <RouterProvider router={router} />
      </PrivacyProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
